<template>
  <input
    :class="`${
      isEditable ? '' : 'cursor-auto'
    } w-full border-2 px-3 py-2 resize-none font-mono text-sm focus:outline-none bg-gray-50 hover:border-primary-100 dark:bg-dark-400 dark:border-dark-400`"
    :disabled="!isEditable"
    style="transition: border-color 0.5s"
    :style="{ width: width, borderRadius: radius }"
    :type="type"
    :value="value"
    wrap="off"
    @input="changeText"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '400px'
    },
    radius: {
      type: String,
      default: '1rem'
    },
    type: {
      type: String,
      default: 'text'
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      required: true
    },
    onChange: {
      type: Function
    }
  },
  setup(props) {
    const changeText = (e: Event) => {
      const target = e.target as HTMLTextAreaElement
      if (props.onChange) {
        props.onChange(target.value)
      }
    }

    return {
      changeText
    }
  }
})
</script>

<style></style>
